import { render } from "./ActionCenter.vue?vue&type=template&id=ed137d6c&scoped=true"
import script from "./ActionCenter.vue?vue&type=script&lang=js"
export * from "./ActionCenter.vue?vue&type=script&lang=js"

import "./ActionCenter.vue?vue&type=style&index=0&id=ed137d6c&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹 (2)\\前端\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed137d6c"]])

export default __exports__